const SvgArrowDownGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M8 11.334a.665.665 0 01-.471-.196L4.196 7.805a.666.666 0 11.942-.943L8 9.724l2.862-2.862a.666.666 0 11.943.943l-3.333 3.333a.666.666 0 01-.472.196' />
  </svg>
);

export default SvgArrowDownGlyph;
